export default {"src":"/_next/static/media/new-ollie-box.3758afd2.svg","height":110,"width":110,"blurWidth":0,"blurHeight":0};